<template>
  <div>
    <Subheader title="Login" />

    <div class="app-content-column">
      <div class="card">
        <h5>Welcome to the Mzingo Partners Community</h5>

        <form class="form" @submit.stop.prevent="handleLoginFormSubmit">
          <FormError v-if="showFormErrors" :form-errors="formErrors" />

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="username">
            <input
              v-model="userData.username"
              type="text"
              placeholder="Username"
              autocomplete="username"
              autocorrect="off"
              autocapitalize="none"
              required
            />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="password">
            <input
              v-model="userData.password"
              type="password"
              placeholder="Password"
              autocomplete="current-password"
              autocorrect="off"
              autocapitalize="none"
              required
            />
          </Field>

          <div class="button-wrapper is-centered">
            <button type="submit" class="large-button">
              Login
            </button>
          </div>

          <div class="row" style="text-align: center; margin-top: 1.5rem;">
            <router-link :to="{ name: 'UserOnboarding' }">
              <h5 @click="sendCreateProfileEventGA">Sign Up</h5>
            </router-link>
          </div>
          <div class="row" style="text-align: center; margin-top: 1.5rem;">
            <router-link :to="{ name: 'ForgotPassword' }">
              <p>Forgot your Password?</p>
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import Field from '@/components/Field'
import FormError from '@/components/FormError'

import User from '@/services/users'
import { validateInputLength } from '@/services/forms'

export default {
  name: 'Login',
  components: {
    Subheader,
    Field,
    FormError,
  },
  data() {
    return {
      userData: {
        username: '',
        password: '',
      },
      loading: false,
      //field errors are from client-side validation
      fieldErrors: [],
      showFieldErrors: false,
      //form errors are from server-side validation
      formErrors: [],
      showFormErrors: false,
    }
  },
  methods: {
    async handleLoginFormSubmit() {
      this.loading = true
      this.fieldErrors = this.collectFieldErrors()

      if (this.fieldErrors.length) {
        this.showFieldErrors = true
      } else {
        try {
          const response = await User.api.login(this.userData.username, this.userData.password)
          this.$store.commit('UPDATE_USER', response.user)
          this.$store.commit('UPDATE_USER_TOKEN', response.token)

          if (this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect })
          } else if (this.$route.query.projectId) {
            this.$router.push({
              name: 'Project',
              params: { projectId: this.$route.query.projectId },
            })
          } else {
            this.$router.push({ name: 'Home' })
          }
        } catch (error) {
          const { response } = error
          if (response && response.data) {
            this.formErrors = response.data
            this.showFormErrors = true
          }
          return
        } finally {
          this.loading = false
        }
      }
    },
    collectFieldErrors() {
      const errors = []
      Object.keys(this.userData).forEach(field => {
        const error = validateInputLength(field, this.userData[field])
        if (error) {
          errors.push(error)
        }
      })
      return errors
    },
    /** Google Analytics - Send "Start Creating Profile" event to GA. */
    sendCreateProfileEventGA() {
      this.$ga.event({
        eventCategory: 'Start Creating Profile',
        eventAction: 'From Login Page',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
}
</style>
